const supportedMediaTypes = [
    'video/',
    'audio/',
    'application/octet-stream',
    'application/mp4',
    'application/x-mpegURL',
    'application/vnd.apple.mpegurl',
    'application/ogg'
];
export async function isMediaUrl(url) {
    if (!isUrl(url))
        return false;
    try {
        const response = await fetch(url, { method: 'HEAD' });
        const header = response.headers.get('Content-Type') || '';
        return supportedMediaTypes.some((mediaType) => header.startsWith(mediaType));
    }
    catch (error) {
        console.error('Failed to fetch the URL', error);
        return false;
    }
}
export function isUrl(url) {
    const URL_REGEX = /^(http|https):\/\/(?:www\.)?[\dA-Za-z-]+(?:\.[A-Za-z]{2,})+(?:\/[^ "]+)?(?:\?.*)?$/;
    return URL_REGEX.test(url);
}
export const removeTrailingSlash = (url) => {
    return url.slice(-1) === '/' ? (url = url.slice(0, -1)) : url;
};
